export const ALL_DOWNLOADS_OBJ = {
  generalInfo: true,
  programCaseStatements: true,
  govAndStaff: true,
  fiscalRegulatory: true,
  partnerships: true,
  awardsRecogPub: true,
  attachments: true,
  notesVerbiage: true,
};

export const CHECKBOX_FIELDS = [
  {
    name: 'generalInfo',
    label: 'General Information',
  },
  {
    name: 'programCaseStatements',
    label: 'Programs',
  },
  {
    name: 'govAndStaff',
    label: 'Governance/Staff',
  },
  {
    name: 'fiscalRegulatory',
    label: 'Fiscal/Regulatory',
  },
  {
    name: 'partnerships',
    label: 'Partnerships',
  },
  {
    name: 'awardsRecogPub',
    label: 'Awards/Recognition/Publicity',
  },
  {
    name: 'notesVerbiage',
    label: 'Notes/Verbiage',
  },
];
